import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Home from '../posts/home.mdx'

const IndexPage = () => (
  <Home>
  </Home>
)

export default IndexPage
